/**
 *
 * TextNoWrap
 *
 */

import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { useIsOverflowing } from '@/hooks';

import Tooltip from '../Tooltip';

const TextNoWrap = ({
  children,
  Component = Typography,
  tooltip,
  showTooltipOnOverflow,
  tooltipProps,
  ...props
}) => {
  const [isOverflowing, overflowRef] = useIsOverflowing({
    enabled: showTooltipOnOverflow && !tooltip,
  });

  const component = (
    <Component
      noWrap
      // Render as a <div> so block-level children (icons, styled wrappers, etc.)
      // don't trigger a validateDOMNesting warning inside Typography's default <p>.
      component="div"
      ref={showTooltipOnOverflow && !tooltip ? overflowRef : undefined}
      {...props}
    >
      {children}
    </Component>
  );

  if (tooltip) {
    return (
      <Tooltip title={children} {...tooltipProps}>
        {component}
      </Tooltip>
    );
  }

  if (showTooltipOnOverflow) {
    return (
      <Tooltip
        title={children}
        disableHoverListener={!isOverflowing}
        disableFocusListener={!isOverflowing}
        disableTouchListener={!isOverflowing}
        {...tooltipProps}
      >
        {component}
      </Tooltip>
    );
  }

  return component;
};

TextNoWrap.propTypes = {
  children: PropTypes.node,
  Component: PropTypes.elementType,
  tooltip: PropTypes.bool,
  showTooltipOnOverflow: PropTypes.bool,
  tooltipProps: PropTypes.object,
};

export default memo(TextNoWrap);
